import { dynamicQuoteApplyURL, getReferrerKeys, updatePhoneNumber } from './campaigns';
import { cookie } from '../util/storage';

let campaignData;
const organic = (cookieToCheck) => {
  const referrerInfo = {
    google: ['421903', 'Google_Search'],
    bing: ['421904', 'Bing_Search'],
    yahoo: ['OSYIFP', 'Yahoo_Search'],
    cigna: ['421905', 'Other_Cigna_page'],
    default: ['421906', 'Typed_URL']
  };
  const [referrerCode, referrerValue] = getReferrerKeys(referrerInfo);

  if (['ifpMedCampaign', 'campaignPID', 'campaignEID'].some(e => cookieToCheck === e)) {
    cookie.set(cookieToCheck, referrerCode);
    const phoneNumber = campaignData[referrerCode] || '18002446224';
    if (cookieToCheck === 'ifpMedCampaign') {
      updatePhoneNumber(phoneNumber);
      dynamicQuoteApplyURL(referrerCode);
    }
  } else if (['campaignSource', 'campaignMedium'].some(e => cookieToCheck === e)) {
    cookie.set(cookieToCheck, referrerValue);
  }
};

const updateCampaign = (key, val) => {
  if (val && val !== 'ANCORG' && val !== 'CSBORG' && val !== 'Cigna Supplemental') {
    if (key === 'ifpMedCampaign' || key === 'utm_campaign') {
      if (campaignData[val]) {
        cookie.set('ifpMedCampaign', val);
        updatePhoneNumber(campaignData[val]);
        dynamicQuoteApplyURL(val);
      } else {
        organic('ifpMedCampaign');
      }
    } else if (key === 'campaignMedium' || key === 'utm_medium') {
      cookie.set('campaignMedium', val);
    } else if (key === 'campaignSource' || key === 'utm_source') {
      cookie.set('campaignSource', val);
    } else if (key === 'campaignPID' || key === 'PID') {
      cookie.set('campaignPID', val);
    } else if (key === 'campaignEID' || key === 'EID') {
      cookie.set('campaignEID', val);
    }
  } else {
    organic(key);
  }
};

const processCampaignURL = () => {
  if (location.search === '') {
    ['campaignMedium', 'campaignSource', 'campaignPID', 'campaignEID', 'ifpMedCampaign'].forEach(element => organic(element));
  } else {
    const [, searchString] = location.search.split('?');
    const searchValuesObj = {};

    searchString.split('&').forEach((element) => {
      const [key, val] = element.split('=');
      searchValuesObj[key] = val;
    });
    /* eslint-disable no-confusing-arrow */
    [
      { query: 'utm_medium', cookie: 'campaignMedium' },
      { query: 'utm_source', cookie: 'campaignSource' },
      { query: 'PID', cookie: 'campaignPID' },
      { query: 'EID', cookie: 'campaignEID' },
      { query: 'utm_campaign', cookie: 'ifpMedCampaign' }
    ].forEach(element => searchValuesObj[element.query]
    ? updateCampaign(element.query, searchValuesObj[element.query])
    : updateCampaign(element.cookie));
  }
};

export default (jsonData) => {
  campaignData = jsonData;
  if (cookie.get('ifpMedCampaign') && !location.search.includes('utm_campaign')) {
    ['campaignMedium', 'campaignSource', 'campaignPID', 'campaignEID', 'ifpMedCampaign'].forEach(element => updateCampaign(element, cookie.get(element)));
  } else {
    processCampaignURL();
  }
};



// WEBPACK FOOTER //
// ./node_modules/cigna-frontend/js/campaigns/ifp-medical.js